module.exports = __webpack_public_path__ + "img/ho-supra.5cd34d33.jpg";